import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "swiper/css";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import ServiceInclude from "../../component/ServiceInclude";
import { Helmet } from "react-helmet";


const NewYork = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);


    return (
        <>

            <Helmet prioritizeSeoTags={true}>
                <meta http-equiv="content-type" content="text/html; charset=utf-8" />
                <meta name="format-detection" content="telephone=no" />
                <title>Leading salesforce Consultant and Partner in new york</title>
                <meta name="viewport" content="width=device-width, initial-scale=1" />

                <meta name="description"
                    content="Transform your business with Codezix – leading Salesforce consulting and implementation services in New York. Customized strategies to help you grow."
                />
                <meta
                    name="keywords"
                    content="Salesforce consulting new york Salesforce implementation new york Codezix Salesforce services CRM solutions new york Salesforce experts new york Salesforce partner new york Custom Salesforce solutions"
                />
            </Helmet>

            <div className="service-banner top bottom">
                <div className="container">
                    <div className='explore-heading'>
                        <h2>Salesforce Consultant New York</h2>
                    </div>
                    <div className="service-img mt-4">
                        <img src={require('../../assets/images/country/new-york.webp')} alt="Salesforce consulting new york" />
                    </div>
                </div>
            </div>

            <div className="container">
                <div className="row">
                    <div className="col-lg-3">
                        <ServiceInclude />
                    </div>

                    <div className="col-lg-9">
                        <div className="salesforce-service">
                            <div className='explore-heading text-left'>
                                <h2>Trusted Salesforce Consultant in New York and Strategic Partner for Your Business</h2>
                            </div>
                            <p className="prose-lg wow fadeUp">In an era where digital transformation drives competitive advantage, businesses need more than just tools—they need the right expertise to maximize their technology investments. Codezix, a leading Salesforce consultant and partner in New York, helps organizations turn Salesforce into a strategic asset.</p>
                            <p className="prose-lg wow fadeUp">At Codezix, we understand that every business has unique challenges. That’s why we offer customized Salesforce solutions that go beyond standard implementation. Whether you're looking to launch Salesforce for the first time, enhance existing processes, or integrate complex systems, our certified experts guide you through every step.</p>
                            <p className="prose-lg wow fadeUp">As a trusted Salesforce consultant in New York, we combine deep technical knowledge with a local market understanding to deliver impactful results. Our team has successfully worked with companies across industries—including finance, healthcare, real estate, and technology—to streamline workflows, improve customer engagement, and drive measurable growth.</p>
                            <p className="prose-lg wow fadeUp">What sets Codezix apart is our commitment to partnership. We don’t just deliver solutions—we work closely with your team to ensure long-term success. From initial discovery and system design to user training and ongoing support, we’re with you at every stage of your Salesforce journey.</p>
                            <p className="prose-lg">For businesses seeking a reliable and forward-thinking Salesforce consultant in New York, Codezix is the name to trust. With a strong focus on innovation, client satisfaction, and technical excellence, we’re proud to be helping New York businesses thrive in today’s competitive landscape.</p>
                            <p className="prose-lg">Ready to elevate your CRM strategy? Contact Codezix today to learn how we can help you make Salesforce work smarter for your business.</p>
                        </div>

                        <div className='cloud-demo' >
                            <div className='explore-heading text-left'>
                                <h2>Expert Salesforce Consulting Service in New York – Customized Solutions for Your Business</h2>
                                <p className="prose-lg">In today’s competitive market, leveraging a powerful CRM like Salesforce isn’t just a smart move—it’s essential. But to truly unlock its potential, you need more than out-of-the-box functionality. You need a strategic partner who understands your business and knows how to tailor Salesforce to fit your goals. That’s where Codezix comes in.</p>
                                <p className="prose-lg">At Codezix, we offer expert Salesforce consulting in New York, helping businesses across industries design, implement, and optimize Salesforce solutions that drive real results. Whether starting from scratch or refining an existing system, our team works closely with you to ensure every aspect of your Salesforce environment supports your long-term success.</p>
                                <p className="prose-lg">Our approach is rooted in customization. We begin by understanding your business processes, challenges, and growth objectives. From there, we craft a Salesforce solution that enhances productivity, improves customer engagement, and delivers clear ROI. Our services include everything from initial setup and system integrations to automation, analytics, and ongoing support.</p>
                                <p className="prose-lg">What makes Codezix different? It’s our combination of local insight and technical expertise. As a trusted provider of Salesforce consulting in New York, we understand the fast-paced demands of businesses operating in one of the world’s most dynamic markets.</p>
                                <p className="prose-lg">We don't just deliver projects—we build partnerships. Our team is committed to transparency, collaboration, and innovation at every step of your Salesforce journey.</p>
                                <p className="prose-lg">If you're looking to maximize your Salesforce investment with a team that puts your needs first, Codezix is ready to help. Discover how our customized consulting services can transform your CRM strategy and accelerate business growth.</p>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={require('../../assets/images/country/consulting.webp')} alt='Salesforce implementation new york' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> Salesforce Consulting</h3>
                                            <p className="wow fadeUp prose-lg">Our Salesforce-certified consultants in New York thoroughly analyze your business needs, evaluate your processes, and provide strategic guidance tailored to your goals. We tackle CRM challenges, helping you resolve issues like low sales productivity and departmental misalignment.Our certified consultants assess your business needs, streamline processes, and provide strategic guidance tailored to your goals. We help resolve common CRM challenges, including low sales productivity and misalignment between departments, ensuring smoother operations and improved overall efficiency.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={require('../../assets/images/country/implementation.webp')} alt='Codezix Salesforce services' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> Salesforce Implementation</h3>
                                            <p className="wow fadeUp prose-lg"> Elevate your business with our expert implementation services. Our certified professionals specialize in setting up, customizing, and configuring cloud-based solutions and add-ons, helping you drive innovation, streamline operations, and accelerate growth with technology tailored to your unique business needs</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={require('../../assets/images/country/customization.webp')} alt='CRM solutions new york' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Salesforce Customization</h3>
                                            <p className="wow fadeUp prose-lg"> Our certified consultants evaluate your business processes to deliver strategic guidance tailored to your goals. We help overcome CRM challenges, improve sales productivity, and enhance collaboration across departments, ensuring greater efficiency and smoother operations.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={require('../../assets/images/country/development.webp')} alt='Salesforce experts new york' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> Salesforce App Development</h3>
                                            <p className="wow fadeUp prose-lg">Break down departmental silos and boost productivity with our seamless integration services. We connect core business systems such as ERP, CMS, DMS, and accounting software to ensure smooth data flow, better collaboration, and improved overall operational efficiency across your organization.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={require('../../assets/images/country/integration.webp')} alt='Salesforce partner new york' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> Salesforce Integration</h3>
                                            <p className="wow fadeUp prose-lg"> Effortlessly migrate from your legacy system with our trusted data migration services in New York. Our experts ensure a smooth, secure transition while preserving the accuracy and integrity of your customer data throughout the entire migration process for minimal disruption.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={require('../../assets/images/country/migration.webp')} alt='Custom Salesforce solutions' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> Salesforce Migration Services</h3>
                                            <p className="wow fadeUp prose-lg"> Seamlessly transition from your legacy system to Salesforce with our trusted migration services in New York! At Codezix, our experts ensure a smooth transfer while preserving the accuracy and integrity of your customer data.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={require('../../assets/images/country/support.webp')} alt='Salesforce consulting new york' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Salesforce Support</h3>
                                            <p className="wow fadeUp prose-lg">We continuously monitor your system to detect and resolve issues before they escalate. With proactive oversight, we reduce downtime, maintain smooth operations, and help prevent major disruptions, keeping your business running efficiently and without unexpected interruptions.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='client-section'>
                            <div className='explore-heading text-left'>
                                <h2>Your Trusted Salesforce Consulting Partner in New York and Beyond</h2>
                                <p className="prose-lg">At Codezix, we provide tailored Salesforce solutions that help businesses streamline operations, boost productivity, and drive growth. As a trusted Salesforce consulting partner in New York, we combine local expertise with global experience to deliver results that matter. From implementation to optimization, our certified team supports clients across industries with precision and care. Whether based in New York or expanding internationally, Codezix ensures your Salesforce platform evolves with your business. Choose a Salesforce consulting partner in New York that’s committed to long-term success—choose Codezix.</p>
                            </div>
                            <div className='row top'>
                                <Swiper
                                    breakpoints={{
                                        425: {
                                            slidesPerView: 2,
                                            spaceBetween: 10,
                                        },
                                        640: {
                                            slidesPerView: 3,
                                            spaceBetween: 10,
                                        },
                                        768: {
                                            slidesPerView: 4,
                                            spaceBetween: 30,
                                        },
                                        1024: {
                                            slidesPerView: 5,
                                            spaceBetween: 30,
                                        },
                                    }}
                                    autoplay={{
                                        delay: 2500,
                                        disableOnInteraction: false,
                                    }}
                                    pagination={{
                                        clickable: true,
                                    }}
                                    modules={[Pagination, Autoplay]}
                                    className="testimonialSwiper-client"
                                >
                                    <SwiperSlide className="col-md-4 col-4">
                                        <div className='client-image-slide-partnerships salesforce_certificate'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/4.webp" alt='Salesforce implementation new york' />
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide className="col-md-4 col-4">
                                        <div className='client-image-slide-partnerships salesforce_certificate'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/1.webp" alt='Codezix Salesforce services' />
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide className="col-md-4 col-4">
                                        <div className='client-image-slide-partnerships salesforce_certificate'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/2.webp" alt='CRM solutions new york' />
                                        </div>
                                    </SwiperSlide>

                                    <SwiperSlide className="col-md-4 col-4">
                                        <div className='client-image-slide-partnerships salesforce_certificate'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/3.webp" alt='Salesforce experts new york' />
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide className="col-md-4 col-4">
                                        <div className='client-image-slide-partnerships salesforce_certificate'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/5.webp" alt='Salesforce partner new york' />
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide className="col-md-4 col-4">
                                        <div className='client-image-slide-partnerships salesforce_certificate'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/6.webp" alt='Custom Salesforce solutions' />
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide className="col-md-4 col-4">
                                        <div className='client-image-slide-partnerships salesforce_certificate'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/7.webp" alt='Salesforce consulting new york' />
                                        </div>
                                    </SwiperSlide>
                                </Swiper>
                            </div>
                        </div>

                        <div className="salesforce-product">
                            <div className='explore-heading text-left'>
                                <h2>Salesforce Consultants in New York Showcasing Expertise Across All Salesforce Clouds</h2>
                                <p className="wow fadeUp prose-lg text-left">Our team of certified Salesforce consultants in New York brings deep expertise across the entire Salesforce ecosystem—including Sales Cloud, Service Cloud, Marketing Cloud, and more. We design tailored solutions that align with your business goals and drive real, measurable impact. Whether you're launching a new Salesforce instance or optimizing an existing one, our consultants deliver scalable strategies for success. As trusted Salesforce consultants in New York, we partner with businesses of all sizes to unlock the full potential of Salesforce and fuel long-term growth.</p>
                            </div>
                            <div class="row mt-5">
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/sales-cloud">
                                            <h3 class="mt-0">Sales Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/service-cloud">
                                            <h3 class="mt-0">Service Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/marketing-cloud">
                                            <h3 class="mt-0">Marketing Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/community-cloud">
                                            <h3 class="mt-0">Community Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/finencial-service-cloud">
                                            <h3 class="mt-0">Financial Services Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/non-profit">
                                            <h3 class="mt-0">Nonprofit Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/cpq">
                                            <h3 class="mt-0">Salesforce CPQ</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/development-company-in-new-york#">
                                            <h3 class="mt-0">Salesforce Chatter</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/community-cloud">
                                            <h3 class="mt-0">Community Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/einstein-analytics">
                                            <h3 class="mt-0">Einstein Analytics</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/development-company-in-new-york#">
                                            <h3 class="mt-0">Salesforce Lightning</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/development-company-in-new-york#">
                                            <h3 class="mt-0">Health Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="salesforce-product">
                            <div className='explore-heading text-center'>
                                <h2>Industries We Serve by Our Expert Salesforce Developers in New York</h2>
                                <p className="prose-lg">At Codezix, our Salesforce developers in New York bring deep industry-specific expertise to every project. We’ve successfully helped businesses in industries such as healthcare, finance, retail, and technology by leveraging Salesforce to streamline operations and improve customer experiences. Whether you're looking to enhance your sales processes or create custom solutions, our Salesforce developers in New York tailor their approach to meet the unique needs of your business. With our in-depth knowledge and technical skills, we ensure that your Salesforce implementation drives efficiency, growth, and long-term success.</p>
                            </div>

                            <div class="row mob-imagebox">
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/healthcare.webp" alt="Salesforce implementation new york" />
                                        <div class="image-text">
                                            <p>Healthcare</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/retail.webp" alt="Codezix Salesforce services" />
                                        <div class="image-text">
                                            <p>E-Commerce</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/logistics.webp" alt="CRM solutions new york" />
                                        <div class="image-text">
                                            <p>Logistics</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/financial.webp" alt="Salesforce experts new york" />
                                        <div class="image-text">
                                            <p>Financial</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/manufacturing.webp" alt="Salesforce partner new york" />
                                        <div class="image-text">
                                            <p>Manufacturing</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/publicsector.webp" alt="Custom Salesforce solutions" />
                                        <div class="image-text">
                                            <p>Public Sector</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/media.webp" alt="Salesforce consulting new york" />
                                        <div class="image-text">
                                            <p>Media</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/it.webp" alt="Salesforce implementation new york" />
                                        <div class="image-text">
                                            <p>IT Industry</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/telecom.webp" alt="Codezix Salesforce services" />
                                        <div class="image-text">
                                            <p>Telecom</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/education.webp" alt="CRM solutions new york" />
                                        <div class="image-text">
                                            <p>Education</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="salesforce-product">
                            <div className='explore-heading text-left'>
                                <h2>Why work with Codezix ?</h2>
                            </div>

                            <div className="row bottom">
                                <div className="col-lg-6">
                                    <div className="why-listing mt-4">
                                        <ul>
                                            <li className="wow fadeUp prose-lg">Salesforce Consulting Partner </li>
                                            <li className="wow fadeUp prose-lg">Leading in-house expertise with 80+ developers and 300+ certifications </li>
                                            <li className="wow fadeUp prose-lg"> 89% repeat business rate, showcasing client trust</li>
                                            <li className="wow fadeUp prose-lg">90% client retention rate, ensuring long-term success </li>
                                            <li className="wow fadeUp prose-lg">Over 10 years of industry experience </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="why-listing mt-4">
                                        <ul>
                                            <li className="wow fadeUp prose-lg"> Ongoing Support & Maintenance</li>
                                            <li className="wow fadeUp prose-lg">100% global Salesforce support, covering all time zones </li>
                                            <li className="wow fadeUp prose-lg">100% in-house code development for quality control </li>
                                            <li className="wow fadeUp prose-lg"> 99% on-time project delivery for seamless execution</li>
                                            <li className="wow fadeUp prose-lg">Comprehensive quality assurance through rigorous testing for reliable and efficient Salesforce solutions </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='cloud-demo' >
                            <div className='explore-heading text-left'>
                                <h2>Customer Success Stories</h2>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/casestudy/salesforce/images/pd1.webp" alt='Salesforce implementation new york' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">3 PL Central </h3>
                                            <p className="wow fadeUp prose-lg">Based in California, our client <strong>3PL Central </strong>provides a warehouse management system (WMS) to businesses. Their WMS enhances operational efficiency, boosts customer satisfaction, and supports business growth. </p>
                                        </div>
                                        {/* <div className="services_button_right">
                                            <Link to="" ></Link>
                                        </div> */}
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/casestudy/salesforce/images/24-Fit-Club1.webp" alt='Codezix Salesforce services' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">24 Fit Club </h3>
                                            <p className="wow fadeUp prose-lg">Based in the UK, <strong>24 Fit Club</strong> is a dedicated fitness community committed to helping individuals stay healthy. Their expert team provides top-tier health and fitness advice, offering the latest insights and online classes to empower clients and promote body positivity. </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/casestudy/salesforce/images/salesforce1.webp" alt='CRM solutions new york' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Active Campaign </h3>
                                            <p className="wow fadeUp prose-lg"> Salesforce is one of the largest CRM solutions, offering a powerful enterprise customer relationship management (CRM) application compatible across multiple devices. With a robust app marketplace, Salesforce enhances marketing and sales alignment, delivering better leads and high-quality pipelines.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/casestudy/salesforce/images/advologix.webp" alt='Salesforce experts new york' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Advologix</h3>
                                            <p className="wow fadeUp prose-lg"> Based in Sugarland, Texas, Advologix is a digital consultancy specializing in legal document and case matter processing for law firms, legal departments, and public service organizations. They develop centralized information management systems to streamline case processing from initiation to resolution.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/casestudy/salesforce/images/concert_health.webp" alt='Salesforce partner new york' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Concert Health</h3>
                                            <p className="wow fadeUp prose-lg">Concert Health empowers physician practices to deliver integrated behavioral health services, including care management, brief therapy interventions, and psychiatric consultations. They provide expert clinicians (therapists & psychiatrists), industry know-how, and cutting-edge technology to enhance patient care.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/casestudy/salesforce/images/at-home-solutions.webp" alt='Custom Salesforce solutions' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">At Home Solutions</h3>
                                            <p className="wow fadeUp prose-lg">Based in New York, At Home Solutions provides personalized healthcare services, ensuring the highest quality of life for individuals of all ages. For over a decade, they have delivered affordable and effective care, offering the right companionship, services, and support to enhance well-being.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='cloud-demo' >
                            <div className='explore-heading text-left'>
                                <h2>Customer Success Stories</h2>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/blog/commerce.webp" alt='Salesforce consulting new york' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Salesforce Commerce Cloud: Everything You Need to Know </h3>
                                            <p className="wow fadeUp prose-lg">In today’s fast-paced digital world, e-commerce is essential for business success, driving intense competition as companies strive to meet rising online shopping demands. With consumers increasingly relying on digital platforms, businesses must adopt robust, scalable solutions to stay ahead.</p>
                                        </div>
                                        {/* <div className="services_button_right">
                                            <Link to="" ></Link>
                                        </div> */}
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/blog/agent.webp" alt='Salesforce implementation new york' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> Ultimate Guide to Salesforce Agentforce</h3>
                                            <p className="wow fadeUp prose-lg">The latest buzz in 2024 is all about Salesforce Agentforce. On Day Three of Dreamforce 2024, Salesforce introduced the third wave of AI, unveiling Agentforce—a revolutionary tool designed to empower employees with advanced AI capabilities. </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/blog/marketing.webp" alt='Codezix Salesforce services' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> What is Salesforce Mulesoft and How Codezix Can Help in Implementation and Customization of Mulesoft</h3>
                                            <p className="wow fadeUp prose-lg"> In today’s fast-paced digital world, businesses are leveraging multiple applications, platforms, and services to streamline operations and improve customer experiences. However, connecting all these systems seamlessly is often a significant challenge. That’s where Salesforce Mulesoft...</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}

export default NewYork;